"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllChunkSize = exports.defaultExtractor = exports.runCashoutExtractor = exports.runsLocationsExtractor = exports.runsHistoryExtractor = exports.runExtractor = exports.RunGroupTypes = exports.RunEvents = exports.RunStatus = void 0;
var RunStatus;
(function (RunStatus) {
    RunStatus["ALL"] = "all";
    RunStatus["CLOSED"] = "closed";
    RunStatus["OPEN"] = "open";
})(RunStatus = exports.RunStatus || (exports.RunStatus = {}));
var RunEvents;
(function (RunEvents) {
    RunEvents["UPDATED"] = "run updated";
    RunEvents["DELETED"] = "run deleted";
    RunEvents["CREATED"] = "run created";
})(RunEvents = exports.RunEvents || (exports.RunEvents = {}));
var RunGroupTypes;
(function (RunGroupTypes) {
    RunGroupTypes["TaskIds"] = "taskIds";
})(RunGroupTypes = exports.RunGroupTypes || (exports.RunGroupTypes = {}));
var runExtractor = function (response) { return response.run; };
exports.runExtractor = runExtractor;
var runsHistoryExtractor = function (response) { return response; };
exports.runsHistoryExtractor = runsHistoryExtractor;
var runsLocationsExtractor = function (response) { return response; };
exports.runsLocationsExtractor = runsLocationsExtractor;
var runCashoutExtractor = function (response) { return response; };
exports.runCashoutExtractor = runCashoutExtractor;
var defaultExtractor = function (response) { return response; };
exports.defaultExtractor = defaultExtractor;
exports.GetAllChunkSize = 450;
//# sourceMappingURL=runs.consts.js.map